/* eslint-disable max-len */

/**
 * Available services/workflows in the application
 */
export const SERVICES = [
  {
    name: "Germline Analysis",
    to: "/portal/projects/create_project?type=GERMLINE",
    description:
      "SNVs, SVs and their annotations. Implements the GATK Best Practices pipeline.",
  },
  {
    name: "Germline Trio Analysis",
    to: "/portal/projects/create_project?type=GERMLINE_TRIO",
    description: "Compare germline variants between individuals.",
  },
  {
    name: "Somatic Analysis",
    to: "/portal/projects/create_project?type=SOMATIC",
    description:
      "SNVs, SVs, CNVs, MSI, Fusions and their annotations. Implements the GATK Best Practices pipeline.",
  },
];
